<div class="plan-downgrade-error-page">
  <div class="error-prompt-wrapper">
    <div class="avatar-container">
      <img src="../../../images/downgrade-plan.png" />
    </div>
    <mode-error-prompt
      [title]="errorTitle"
      [instructions]="errorInstructions"
      [setCustomCss]="true"
      class="error-prompt"
    >
      <mode-error-prompt-actions class="error-prompt-actions-container">
        <capra-button
          *ngIf="!hasNoSecondary"
          class="btn btn-secondary btn-lg margin-right-10 free"
          variant="secondary"
          [text]="errorSecondaryActionLabel"
          (clicked)="closeModal($event)"
        ></capra-button>

        <mode-calendly-popup-button>
          <button class="btn btn-lg btn-primary upgrade">{{ errorPrimaryActionLabel }}</button>
        </mode-calendly-popup-button>
      </mode-error-prompt-actions>
    </mode-error-prompt>
  </div>
</div>
